import React from "react";

import { useSelector } from "react-redux";

import InvestmentInterestTable from "../dashboard/investment/InvestmentInterestTable";

const UserInterested = ({ investmentID, cycle }) => {
  const investment = useSelector((state) => state?.investment?.investment);

  return (
    <div>
      <div className="mt-10 ">
        <InvestmentInterestTable
          cycle={cycle}
          investmentID={investmentID || investment?.id}
        />
      </div>
    </div>
  );
};

export default UserInterested;
